// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9dd26a5","667":"84c81e2c","977":"ab47c2d9"}[chunkId] + ".chunk.js";
};